module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};



//////////////////
// WEBPACK FOOTER
// ./~/md5.js/~/readable-stream/lib/internal/streams/from-browser.js
// module id = 640
// module chunks = 42